export default __webpack_public_path__ + "static/media/hd_ic_chat.54ca3490.svg";